export function trim(str: string) {
  return str.replace(/^\s+|\s+$/g, '');
}
